import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";

import { User } from "pwapi";

import {
  caseDetail,
  caseLog,
  qaReviews,
  wipeCaseDetail,
} from "shared/actions/caseDetailActions";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import ApplicationState from "store/ApplicationState";
import { useAppSelector } from "store/hooks";
import { AppDispatch } from "store/store";

const CasePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentUser: User | undefined = useSelector(
    ({ auth }: ApplicationState) => auth.user
  );
  const qaReviewsInViewer = useAppSelector((state) =>
    selectFeatureFlag(state, "qaReviewsInViewer")
  );
  const userCanSeeReviews =
    qaReviewsInViewer &&
    (currentUser?.is_superuser ||
      ["lab_admin", "dermpath", "admin"].includes(
        currentUser?.user_type || ""
      ));

  const params = useParams<{ case_id: string }>();
  let { case_id = "" } = params;
  const caseId = case_id ? parseInt(case_id) : undefined;

  useEffect(() => {
    // Runs once when mounting
    dispatch(wipeCaseDetail());
    return () => {
      // Runs once on unmounting, in reversed order for clarity
      dispatch(wipeCaseDetail());
    };
  }, []);

  useEffect(() => {
    if (caseId) {
      dispatch(caseDetail(caseId));
      dispatch(caseLog(caseId));
      userCanSeeReviews && dispatch(qaReviews(caseId));
    }
  }, [caseId]);

  return <Outlet />;
};

export default CasePage;
